export const dashboardProjects = [
  {
    id: 1,
    key: 'ess-grid-map',
    viewType: 'gridMapEss',
    name: '배전망 ESS Project',
    variantLabel: 'Static',
    category: 'Energy',
    status: 'In Progress',
    statusClass: 'status-blue',
    owner: 'LEEJIN',
    timeline: '2026 Q2',
    summary: '변전소와 배전선로를 선택하여 네이버 지도에서 배전망 ESS 데이터를 확인합니다.',
    milestones: [
      'Site review completed',
      'Initial business structure drafted',
      'Technical coordination in progress',
    ],
    nextActions: [
      'Finalize project summary',
      'Review financing assumptions',
      'Prepare stakeholder meeting materials',
    ],
  },
  {
    id: 4,
    key: 'ess-grid-map-dynamic',
    viewType: 'gridMapEssDynamic',
    name: '배전망 ESS Project',
    variantLabel: 'Dynamic',
    category: 'Energy',
    status: 'In Progress',
    statusClass: 'status-blue',
    owner: 'LEEJIN',
    timeline: '2026 Q2',
    summary: '변전소와 배전선로를 선택하여 동적 네이버 지도에서 배전망 ESS 데이터를 확인합니다.',
    milestones: [
      'Dynamic map structure connected',
      'Filtering and rendering logic configured',
      'Interactive review in progress',
    ],
    nextActions: [
      'Refine dynamic interaction flow',
      'Tune rendering performance',
      'Prepare comparison against static version',
    ],
  },
  {
    id: 5,
    key: 'ess-grid-map-static-test',
    viewType: 'gridMapEssStaticTest',
    name: '배전망 ESS Project',
    variantLabel: 'Static + Test',
    category: 'Energy',
    status: 'Testing',
    statusClass: 'status-blue',
    owner: 'LEEJIN',
    timeline: '2026 Q2',
    summary: '기존 변전소-배전선로 정적 HTML 데이터를 하나로 통합하여 전체 배전망 ESS 후보 좌표를 확인합니다.',
    milestones: [
      'Static map files integrated',
      'Large point preview configured',
      'Integrated map review ready',
    ],
    nextActions: [
      'Review integrated marker rendering',
      'Compare against individual static maps',
      'Decide whether to promote into Dynamic version',
    ],
  },
  {
    id: 2,
    key: 'grid-capacity-map',
    viewType: 'gridMapCapacity',
    name: '계통 여유용량 조회',
    category: 'Energy',
    status: 'In Progress',
    statusClass: 'status-green',
    owner: 'LEEJIN',
    timeline: '2026 Q2',
    summary: '용량 기준 필터와 함께 지도에서 계통 여유용량 데이터를 확인합니다.',
    milestones: [
      'Data collection completed',
      'Initial screening logic configured',
      'Map display optimization in progress',
    ],
    nextActions: [
      'Improve rendering speed',
      'Add filtering options',
      'Prepare output export function',
    ],
  },
  {
    id: 3,
    key: 'system-db-update',
    viewType: 'systemDbUpdate',
    name: '계통 DB 관리',
    category: 'Database',
    status: 'Ready',
    statusClass: 'status-purple',
    owner: 'LEEJIN',
    timeline: '2026 Q2',
    summary: '한전 직접 수집, 실행 로그 확인, 계통 DB 데이터 탐색을 한 화면에서 관리합니다.',
    milestones: [
      '보수적 수집 모드 적용',
      '실행 로그 확인 구조 정리',
      'DB 탐색 화면 연계',
    ],
    nextActions: [
      '시도별 주소 재수집 실행',
      '선로용량 수집 결과 검증',
      'DB 적재 상태 확인',
    ],
  },
];

export const dashboardDocuments = [
  { id: 1, title: 'Project Summary Draft', category: 'Project', updatedAt: '2 hours ago' },
  { id: 2, title: 'Financing Structure Review', category: 'Finance', updatedAt: 'Yesterday' },
];

export const dashboardTasks = [
  { id: 1, title: 'Prepare investment memo', status: 'In Review' },
  { id: 2, title: 'Confirm project schedule', status: 'Open' },
  { id: 3, title: 'Update stakeholder list', status: 'Done' },
];

export const dashboardMessages = [
  { id: 1, sender: 'Operations Team', subject: 'Updated technical schedule', read: false },
  { id: 2, sender: 'Legal Team', subject: 'Draft agreement comments', read: true },
];
